export default __webpack_public_path__ + "static/media/message_icon.1118924f.svg";